// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loading-center .loading-text {
  margin-top: 20px;
  color: #333;
  font-size: 1.25em;
}
.loading-center .svg-background {
  position: relative;
  width: 100px;
  height: 100px;
}

.svg-background span {
  width: 3vmin;
  height: 6vmin;
  border-radius: 3vmin;
  backface-visibility: hidden;
  position: absolute;
  animation-name: move;
  animation-timing-function: cubic-bezier(0.4, 0, 1, 0.8);
  animation-iteration-count: infinite;
  animation-duration: 3s;
  top: calc(50% - 3vmin);
  left: 50%;
  transform-origin: -3vmin center;
}
.svg-background span:nth-child(1) {
  background: #7db7cc;
  animation-delay: -0.5s;
  opacity: 0;
}
.svg-background span:nth-child(2) {
  background: #7db7cc;
  animation-delay: -1s;
  opacity: 0;
}
.svg-background span:nth-child(3) {
  background: #19608f;
  animation-delay: -1.5s;
  opacity: 0;
}
.svg-background span:nth-child(4) {
  background: #7db7cc;
  animation-delay: -2s;
  opacity: 0;
}
.svg-background span:nth-child(5) {
  background: #02bfff;
  animation-delay: -2.5s;
  opacity: 0;
}
.svg-background span:nth-child(6) {
  background: #7db7cc;
  animation-delay: -3s;
  opacity: 0;
}

@keyframes move {
  0% {
    transform: scale(1) rotate(0deg) translate3d(0, 0, 1px);
  }
  30% {
    opacity: 1;
  }
  100% {
    z-index: 10;
    transform: scale(0) rotate(360deg) translate3d(0, 0, 1px);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/loadingSvg2.scss"],"names":[],"mappings":"AAIA;EAEE,eAAA;EAGA,QAAA;EAGA,aAAA;EAGA,0CAAA;EAGA,0BAAA;EAGA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAdF;;AAqBE;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;AAlBJ;AAqBE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AAnBJ;;AA2BA;EACE,YAHe;EAIf,aAAA;EACA,oBALe;EAMf,2BAAA;EACA,kBAAA;EACA,oBAAA;EACA,uDAAA;EACA,mCAAA;EACA,sBAbkB;EAclB,sBAAA;EACA,SAAA;EACA,+BAAA;AAxBF;AAiCE;EAGE,mBAAA;EAGA,sBAAA;EACA,UAAA;AAnCJ;AA4BE;EAGE,mBAAA;EAGA,oBAAA;EACA,UAAA;AA9BJ;AAuBE;EAGE,mBAAA;EAGA,sBAAA;EACA,UAAA;AAzBJ;AAkBE;EAGE,mBAAA;EAGA,oBAAA;EACA,UAAA;AApBJ;AAaE;EAGE,mBAAA;EAGA,sBAAA;EACA,UAAA;AAfJ;AAQE;EAGE,mBAAA;EAGA,oBAAA;EACA,UAAA;AAVJ;;AAeA;EACE;IACE,uDAAA;EAZF;EAeA;IACE,UAAA;EAbF;EAgBA;IACE,WAAA;IACA,yDAAA;EAdF;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
